module.exports = __webpack_public_path__ + "static/media/path3.671628e2.svg";